import "../assets/qreader.css";
import { Fragment, useCallback, useState, useEffect, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Scanner } from "@yudiel/react-qr-scanner";
import { axiosInstance } from "../utils/axios";
import { toast } from "react-toastify"; // Add toast for b

function QReader({ unique_id, confirmed, client_name, id, onClose }) {
  const scannedRecentlyRef = useRef(false);
  const [scannerPaused, setScannerPaused] = useState(false);
  const isComponentMounted = useRef(true);

  const handleResult = useCallback(
    async (text, result) => {
      if (scannedRecentlyRef.current || !isComponentMounted) return;

      scannedRecentlyRef.current = true;

      if (!result || !unique_id) {
        toast.error("Invalid scan data or device ID");
        return;
      }

      const expectedId = String(unique_id).trim();
      const scannedId = String(result).trim();
      if (scannedId === expectedId && confirmed == true) {
        onClose();
        toast.success("Device Already Verified");
        return;
      }

      if (scannedId === expectedId && confirmed == false) {
        try {
          const response = await axiosInstance.post(
            `${window.REACT_APP_API_ENDPOINT}/devices/status/confirm`,
            { id: id }
          );

          if (response.data) {
            toast.success("Device Verified Successfully");
            if (window.location.pathname == "/admin/stock/sold") {
              onClose();
              scannedRecentlyRef.current = false;
            }
          }
        } catch (error) {
          toast.error(
            error.response?.data?.message ||
              "Failed to confirm device. Please try again.",
            { autoClose: 3000 }
          );
          console.error("Error confirming device:", error);
        }
      } else {
        toast.error(
          <span style={{ fontWeight: "bold" }}>
            `QR Code Mismatch - The unique ID {expectedId} of the client{" "}
            {client_name.toUpperCase()} does not match with the scanned QR code`
          </span>,
          { autoClose: false }
        );
      }
      setTimeout(() => {
        scannedRecentlyRef.current = false;
        setScannerPaused(false);
      }, 2000);
    },
    [isComponentMounted]
  );

  const handleError = useCallback(
    (error) => {
      if (isComponentMounted) {
        toast.error("Scanner error: " + error?.message, { autoClose: 3000 });
        console.error("Scanner error:", error);
      }
    },
    [isComponentMounted]
  );

  return (
    <div className="qreaderr">
      <Dialog.Title className="text-sm font-medium text-gray-900 mb-4">
        Please Scan the Device QR Code to Proceed with Verification
      </Dialog.Title>

      <Scanner
        onResult={handleResult}
        onError={handleError}
        constraints={{
          facingMode: "environment",
        }}
        paused={scannerPaused}
        className="w-full aspect-square"
      />

      <div className="mt-4 text-sm text-gray-500">
        Please align the QR code within the scanner frame
      </div>
    </div>
  );
}

export default QReader;
